import script from "./BilledDentitionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BilledDentitionModal.vue?vue&type=script&setup=true&lang=js"

import "./BilledDentitionModal.vue?vue&type=style&index=0&id=3e43b0b4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e43b0b4"]])

export default __exports__